import { IFormFieldProperties } from '../../contracts'

export interface ICaixaEmployeeRegisterFormValues {
  contactName: IFormFieldProperties
  email: IFormFieldProperties
  password: IFormFieldProperties
  confirmPassword: IFormFieldProperties
  phone: IFormFieldProperties
  caixaRole: IFormFieldProperties
  caixaInstitution: IFormFieldProperties
  caixaMatricula: IFormFieldProperties
  caixaDepartment: IFormFieldProperties
}

export interface ICaixaEmployeeRegisterForm {
  form: ICaixaEmployeeRegisterFormValues
  acceptUserTerms: boolean
  acceptEcosystemTerms: boolean
  isFormValid: boolean
}

export const getInitialCaixaEmployeeRegisterForm = (): ICaixaEmployeeRegisterForm => ({
  form: {
    contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
    email: { value: '', isRequired: true, isInvalid: false, message: '' },
    password: { value: '', isRequired: true, isInvalid: false, message: '' },
    confirmPassword: { value: '', isRequired: true, isInvalid: false, message: '' },
    phone: { value: '', isRequired: true, isInvalid: false, message: '' },
    caixaRole: { value: '', isRequired: true, isInvalid: false, message: '' },
    caixaInstitution: { value: 'Caixa Econômica Federal', isRequired: true, isInvalid: false, message: '' },
    caixaMatricula: { value: '', isRequired: true, isInvalid: false, message: '' },
    caixaDepartment: { value: '', isRequired: true, isInvalid: false, message: '' }
  },
  acceptUserTerms: false,
  acceptEcosystemTerms: false,
  isFormValid: false
})

export const updateCaixaEmployeeRegisterForm = (form: ICaixaEmployeeRegisterForm) => form
export const resetCaixaEmployeeRegisterForm = () => getInitialCaixaEmployeeRegisterForm()
